import type { Schema } from "@data-driven-forms/react-form-renderer";
import type { DrawerRoute } from "../../../forms/StudioDrawerWrapper";

export type ChangedComponentsByChangeType = {
  updatedComponentTags: string[];
  addedComponentTags: string[];
  deletedComponentTags: string[];
  hoveredComponent: string | null;
};

export enum ToolTypes {
  "SWIMLANE" = "swimlane",
  "STEP" = "step",
  "FIELD" = "field",
  "TEMPLATE" = "template",
  "HIERARCHY" = "hierarchy",
  "CONNECTOR" = "connector",
  "NULL" = "null"
}

export enum TemplateImportStatusTypes {
  "NOT_STARTED" = "NOT_STARTED",
  "STARTED" = "STARTED",
  "COMPLETED" = "COMPLETED",
  "CANCELLED" = "CANCELLED",
  "FAILED" = "FAILED"
}

export type CollapsedStateSlice = {
  collapsedNodes: string[];
  setCollapsedNodes: (
    callback: (newCollapsedString: string[]) => string[]
  ) => void;
  setNodeCollapseState: (id: string, collapsedState: boolean) => void;
};

export type ToolbarStatesSlice = {
  selectedTool: ToolTypes;
  setSelectedTool: (newTool: ToolTypes) => void;
  toolbarSearchText: string;
  setToolbarSearchText: (searchText: string) => void;
  templateImportStatus: TemplateImportStatusTypes;
  setTemplateImportStatus: (importStatus: TemplateImportStatusTypes) => void;
  templateUID: string | null;
  setTemplateUID: (templateUID: string | null) => void;
};

type UnsetHighlightedComponentCB = () => void;
export type HighlightingStatesSlice = {
  componentsToHighlight: ChangedComponentsByChangeType;
  setComponentsToHighlight: (
    callback: (
      prevComponentsToHighlight: ChangedComponentsByChangeType
    ) => ChangedComponentsByChangeType
  ) => void;
  setHoveredComponent: (
    componentId: string | null
  ) => UnsetHighlightedComponentCB;
};

export type DrawerErrorStateSlice = {
  rulesInEditMode: string[];
  setRulesInEditMode: React.Dispatch<React.SetStateAction<string[]>>;
  formErrors: {
    errors: Record<string, any>;
    schema: Schema;
  };
  setFormErrors: (errors: {
    errors: Record<string, any>;
    schema: Schema;
  }) => void;
  isECADrawerSaving: boolean;
  setIsECADrawerSaving: (isSaving: boolean) => void;
};

type ActivePaneConfig =
  | {
      // Hide the right pane / render default pane
      type: null;
    }
  | {
      // Show the design AI pane
      type: "design-ai";
    }
  | {
      // Show the studio properties pane
      type: "studio-properties";
      config: DrawerRoute;
    }
  | {
      // Show the eca rules pane
      type: "eca-rules";
      config: DrawerRoute;
    };

export type LayoutStateSlice = {
  rightPaneWidth: number;
  setRightPaneWidth: (width: number) => void;
  secondaryPaneWidth: number;
  setSecondaryPaneWidth: (width: number) => void;
  /** Can change based on constance config */
  activePaneDefaultState: ActivePaneConfig;
  activePane: ActivePaneConfig;
  setActivePane: (pane: ActivePaneConfig) => void;
};

export type AppStateSlice = {
  isDeploying: boolean;
  setIsDeploying: (isDeploying: boolean) => void;
};

export type StudioAPIGlobalStore = CollapsedStateSlice &
  ToolbarStatesSlice &
  HighlightingStatesSlice &
  DrawerErrorStateSlice &
  LayoutStateSlice &
  AppStateSlice;
